import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { your, yourHome } from 'src/lib/flow/text';

const isEnabled = ({ inputContext: { answerPrefills } }: FlowContext) => {
  const prefillsDwellingType = answerPrefills['home.dwelling_type']?.value;

  // part of unable to value denials experiment
  if (!prefillsDwellingType || prefillsDwellingType !== 'single_family') {
    return true;
  }

  return false;
};

export function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `What best describes ${yourHome(answers, channel)}?`;
}

export function subtitle({ answers, inputContext: { channel } }: FlowContext) {
  return `This question helps us select comps when preparing ${your(answers, channel)} offer.`;
}

export const slug = () => 'dwelling-type';

export const autoAdvance = () => true;

const dwellingsTypePage: FlowPage = {
  slug,
  title,
  subtitle,
  isEnabled,
  autoAdvance,
  questions: (): FlowQuestion[] => [
    {
      key: 'home.dwelling_type',
      type: 'exclusives_radio_single_select',
      options: [
        {
          label: 'Single-family home',
          value: 'single_family',
        },
        {
          label: 'Townhouse or attached single-family home',
          value: 'townhouse',
        },
        {
          label: 'Apartment or condo',
          value: 'apartment',
        },
        {
          label: 'Mobile or manufactured home',
          value: 'mobile_home',
        },
      ],
    },
  ],
};

export default dwellingsTypePage;
